(function () {
  function storageKey() {
    return 'scroll-pos:' + location.pathname + location.search;
  }

  function restoreScroll() {
    var saved = sessionStorage.getItem(storageKey());
    if (saved === null) return;

    var y = parseInt(saved, 10);
    if (isNaN(y)) return;

    window.scrollTo(0, y);

    setTimeout(function () {
      window.scrollTo(0, y);
      sessionStorage.removeItem(storageKey());
    }, 300);
  }

  function saveScroll() {
    try {
      sessionStorage.setItem(storageKey(), String(window.scrollY));
    } catch (e) {}
  }

  window.addEventListener('pagehide', saveScroll);
  window.addEventListener('load', restoreScroll);
})();
